import { useEffect } from "react";
import {
  createSkillCertificate,
  getCertificate,
  getCertificateLink,
  getCertificateUuid,
  getSkillCertificateLink,
  updateCertificateStatus,
} from "../../../redux/actions/certificate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUnlock,
  faDownload,
  faShareNodes,
  faCopy,
  faTimes,
  faCoins,
  faClose,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ReactSpeedometer from "react-d3-speedometer";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Spinner from "../../../components/Spinner";
import {
  downloadCertificate,
  getLinkFromBuffer,
} from "../../../utils/generateCertificate";
import Gamification from "../../../components/Gamification";
import { getChallengeInfo } from "../../../redux/actions/quiz";
import { leadScoringActivity, userActivity } from "../../../common/constants";
import { useGamification } from "../../../context/GamificationContext";
import { unlockCertificate } from "../../../redux/actions/certificate";
import {getMicroSKillCompletionList } from "../../../redux/actions/userActivity"
import { Dialog } from "@headlessui/react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  TwitterShareButton,
} from "react-share";
import { IKImage } from "imagekitio-react";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
import { toast } from "react-toastify";
import {
  editLastUnlockedCertificateImage,
  editLastVisitedContent,
  editLastVisitedMicroskill,
  editRedirectType,
} from "../../../redux/actions/userActivity";
import { LINKEDIN_REDIRECT_URI } from "../../../config/api_config";
import { createLeadScore } from "../../../redux/actions/pricing";
import { set } from "lodash";
import ProgressBar from "./ProgressBar";
import { getSkillProgress } from "../../../redux/actions/contentPayer";
import SpeedometerOne from "./Speedometers/SpeedometerOne";
import SpeedometerTwo from "./Speedometers/SpeedometerTwo";
import SpeedometerThree from "./Speedometers/SpeedometerThree";
import ChallengeTimer from "./ChallengeTimer";
import { EDIT_LAST_CHALLENGE_CERTIFICATE_ID } from "../../../redux/actions/types";
import { setShowDownloadCertificateBanner } from "../../../redux/actions/adBanner";
import { addUserActivity } from "../../../redux/actions/profileDetails";
import NewMskillTimer from "./NewMskillTimer";
import { Timer } from "./Timer";
import './index.css'


export default function MskillComplete({
  navigateTo,
  isContentPlayer,
  setShowQuizPopup,
  mskill,
  jesData,
  mskillData,
  mSkillProgress
}) {
  
  const [sampleMskillCertificateLink, setSampleMskillCertificateLink] =
    useState(null);
  const [certificateStatus, setCertificateStatus] = useState(null);
  const [challengeInfo, setChallengeInfo] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { contentId } = useParams();
  const { mskill_slug, course_slug, skill_slug } = mskill;
  const userId = useSelector((store) => store?.profileDetails?.id);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const user_name = useSelector((store)=> store?.profileDetails?.name)
  const { setOpenConfirmationModal, setType } = useGamification();
  const [shareModal, setShareModal] = useState(false);
  const email = useSelector((store) => store?.profileDetails?.email);
  const [uniqueCertificateId, setUniquesCertificateId] = useState(null);
  const [downloadButtonDisabled, setDownloadButtonDisabled] = useState(true);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [cutOffValue, setCutOffValue] = useState(65);
  const [isSkillPreview, setIsSkillPreview] = useState(false);
  const [skillCertificate, setSkillCertificate] = useState(null);
  const user_id = useSelector((store) => store?.profileDetails?.id);
  const [skillProgress, setSkillProgress] = useState({});
  const last_completed_mskill = useSelector(store=> store?.userActivity?.last_mskill_completed);
  const isEpsCalculated = useSelector(store=> store?.userActivity?.eps_score?.is_eps_calculated);
  const user_one_day_timer = useSelector(store=> store?.userActivity?.user_one_day_timer);
  const [isTwoMskills , setIsTwoMskills ] = useState(true);
  const [rangeBox , setRangeBox] = useState({style:<></>})
  const [shareUrl , setShareUrl] = useState('');
  const [verifyCertificateUrl , setVerifyCertificateUrl] = useState({});


// console.log(mskillData , 'mskill')

  // const jesData = {
  //   current_score: 90,
  //   score_for_completion: 0.47,
  //   previous_score: 0,
  // };

  // console.log(course_slug, skill_slug, mskill_slug, contentId);
  // console.log(sampleMskillCertificateLink);
  // console.log({certificateStatus});
  console.log('isContentPlayer' , isContentPlayer);
  useEffect(() => {
    dispatch(
      getCertificate(userId, mskill_slug, async (successObj) => {
        // console.log({ successObj })
        dispatch(getCertificateUuid(successObj?.id , "mskill" ,(data1)=>{
          setVerifyCertificateUrl(data1?.data?.url);
        },(err1)=>{} ))
        if (successObj?.certificate_type === "Free") {
          dispatch(
            unlockCertificate(userId, mskill_slug, (res) => {
              dispatch(
                getCertificate(userId, mskill_slug, async (data) => {
                  setCertificateStatus(data);
                  setUniquesCertificateId(data?.unique_certificate_id);
                  dispatch(
                    getCertificateLink(
                      data?.unique_certificate_id,
                      "image_png",
                      (link) => {
                          setSampleMskillCertificateLink(link)
                    
                        setDownloadButtonDisabled(false);
                      }
                    )
                  );
                })
              );
            })
          );
        } else {
          setCertificateStatus(successObj);
          setUniquesCertificateId(successObj?.unique_certificate_id);
          dispatch(
            getCertificateLink(
              successObj?.unique_certificate_id,
              "image_png",
              (link) => {
               
               setSampleMskillCertificateLink(link);
                setDownloadButtonDisabled(false);
              }
            )
          );
        }
      })
    );

    dispatch(
      getChallengeInfo(userId, mskill_slug, (successObj) => {
        setChallengeInfo(successObj[0]);
      })
    );

    dispatch(
      createLeadScore(userId, leadScoringActivity.COMPLETED_MSKILL.type)
    );


    return () => {
      setDownloadButtonDisabled(true);
    };
  }, [mskill_slug]);

  useEffect(() => {
    dispatch(
      createSkillCertificate(user_id, skill_slug, (successObj) => {
        setSkillCertificate(successObj);

        dispatch(
          getSkillCertificateLink(
            successObj?.unique_certificate_id,
            "image_png",
            (link) => {
              
              
                setSkillCertificate((prev) => ({
                  ...prev,
                  certificate_image_link: link,
                }))
              
            }
          )
        );
      })
    );
    dispatch(
      getSkillProgress(user_id, skill_slug, (successObj) =>
        setSkillProgress(successObj)
      )
    );

    dispatch(getMicroSKillCompletionList((successObj)=>{
      // console.log("user list" , successObj);


      if(successObj.length<=2){
        setIsTwoMskills(true);
      }
      else if(successObj?.[0]?.['mskill_slug'] === mskill_slug || successObj?.[1]?.['mskill_slug'] === mskill_slug){
        setIsTwoMskills(true);
      }
      else
      {
        setIsTwoMskills(false);
      }


      switch(successObj.length){
        case 1:
          {
            setRangeBox((prev)=> ({...prev , style : <span className="bg-[#DFFFF3] p-4 text-[12px] md:text-[16px] md:w-1/2 mt-4 rounded-xl">Our learners got<span className="text-[#1CB05E] font-medium "> <img
            urlEndpoint="https://assets.learntube.ai/files/"
            src={`https://assets.learntube.ai/files/Content_player/hired_employee_2.svg?updatedAt=1680594750860`}
            className="h-5 w-5 inline-block mr-1"
            transformation={[
              {
                height: "60",
                width: "60",
              },
            ]}
          />hired/promoted 37%</span>{" "}faster when they learnt and got <span className="text-[#1CB05E] font-medium">5+ certificates <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src={`https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471`}
          className=" h-5 w-5 inline-block mr-1"
          transformation={[
            {
              height: "60",
              width: "60",
            },
          ]}
        /></span></span> }))
          return;
          }
        case 2:
          {
            setRangeBox((prev)=> ({...prev , style : <span className="bg-[#DFFFF3] p-4 text-[12px] md:text-[16px] md:w-1/2 mt-4 rounded-xl">Having <span className="text-[#1CB05E] font-medium ">6+ certificates <img
        urlEndpoint="https://assets.learntube.ai/files/"
        src={`https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471`}
        className="h-5 w-5 inline-block mr-1"
        transformation={[
          {
            height: "60",
            width: "60",
          },
        ]}
      /></span>in your resume increases your chance of getting a job interview to <span className="text-[#1CB05E] font-medium">2.4x<FontAwesomeIcon icon={faArrowTrendUp} className="rounded-full bg-[#1CB05E] text-white w-3 h-3 -mb-[0.5px] ml-1 p-1"/></span></span>}))

        return;
          }
        default:
          {
            setRangeBox((prev)=> ({...prev , style : <span className="bg-[#DFFFF3] p-4 text-[12px] md:text-[16px] md:w-1/2 mt-4 rounded-xl">You get noticed by<span className="text-[#1CB05E] font-medium ">  1.9x more recruiters<img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={`https://assets.learntube.ai/files/Content_player/recruiter_2.svg?updatedAt=1680594750853`}
                    className="h-5 w-5 inline-block mr-1"
                    transformation={[
                      {
                        height: "60",
                        width: "60",
                      },
                    ]}
                  /></span>{" "}when you have <span className="text-[#1CB05E] font-medium">7+ certificates <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471`}
                  className=" h-5 w-5 inline-block mr-1"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                /></span> in your cv.</span>}))
                return;
          }
      }

      
      
      
    } , (errObj)=>{}))

    dispatch(setShowDownloadCertificateBanner(true));
  }, []);

  const handlePremiumClick = (e) => {
    navigate("/pricing");
    Mixpanel.track(Constants.Mixpanel.START_PREMIUM_CLICK, {
      distinct_id: email,
    });
  };

  function updateMskillCertificate(){
    Mixpanel.track(Constants.Mixpanel.SHARE_CERTIFICATE_CLICKED, {
      distinct_id: email,
    });
    dispatch(updateCertificateStatus(certificateStatus?.id , 'download' , (successObj)=> setCertificateStatus((prev)=> ({...prev , is_shared : true}))));
  }


  function certificateDownloadHandler() {
    if (user_token) {
      dispatch(addUserActivity(user_id , userActivity.CERTIFICATE_DOWNLOAD_CLICK,{certificate_id : certificateStatus?.unique_certificate_id},false,null));
      Mixpanel.track(Constants.Mixpanel.CERTIFICATE_DOWNLOAD_CLICK, {
        distinct_id: email,
      });
      if (certificateStatus?.certificate_unlock_status === "unlocked") {
        dispatch(
          getCertificateLink(
            certificateStatus?.unique_certificate_id,
            "image_png",
            (link) => {
             
              setSampleMskillCertificateLink(link);
              downloadCertificate(link);
              setDownloadLoader(false);
            }
          )
        );
      } else {
        dispatch(
          getCertificate(userId, mskill_slug, async (data) => {
            if (data?.certificate_unlock_status === "locked") {
              await dispatch(unlockCertificate(userId, mskill_slug));
              // Trigger Img download
              // console.log({ data })
              setUniquesCertificateId(data?.unique_certificate_id);
              dispatch(
                getCertificateLink(
                  data?.unique_certificate_id,
                  "image_png",
                  (link) => {
                   
                   setSampleMskillCertificateLink(link);
                    downloadCertificate(link);
                    setDownloadLoader(false);
                  }
                )
              );
            } else {
              // Trigger Img download
              setUniquesCertificateId(data?.unique_certificate_id);
              dispatch(
                getCertificateLink(
                  data.unique_certificate_id,
                  "image_png",
                  (link) => {
                    // console.log({ data })
                    downloadCertificate(link);
                    setDownloadLoader(false);
                  }
                )
              );
            }
          })
        );
      }

      dispatch(updateCertificateStatus(certificateStatus?.id , 'download' , (successObj)=> setCertificateStatus((prev)=> ({...prev , is_downloaded : true}))
      ))
    } else navigate("/login");
  }

  function certificatePayDownload() {
    if (user_token) {
      dispatch(
        getCertificate(userId, mskill_slug, async (data) => {
          if (data?.certificate_unlock_status === "locked") {
            await dispatch(
              unlockCertificate(userId, mskill_slug, (successObj) => {
                setCertificateStatus(successObj);
              })
            );
            // Trigger Img download
            // console.log({ data })
            setUniquesCertificateId(data?.unique_certificate_id);
            dispatch(
              getCertificateLink(data.unique_certificate_id, "image_png", (link) => {
                
                setSampleMskillCertificateLink(link);
                downloadCertificate(link);
                setDownloadLoader(false);
              })
            );
          } else {
            // Trigger Img download
            setUniquesCertificateId(data?.unique_certificate_id);
            dispatch(
              getCertificateLink(data.unique_certificate_id, "image_png", (link) => {
                downloadCertificate(link);
                setDownloadLoader(false);
              })
            );
          }
        })
      );
    } else navigate("/login");
  }

  
  function linkedinAuth() {
    try {
      dispatch(
        getCertificate(userId, mskill_slug, (data) => {

          const dateObj = new Date(data?.created_at);
          const month = dateObj.getMonth() + 1;
          const year = dateObj.getFullYear();
          dispatch(getCertificateUuid(data?.id,'mskill',(successObj)=>{

            window.open(`https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${data?.certificate_name}&organizationId=13328177&issueYear=${year}&issueMonth=${month}&certId=${data?.unique_certificate_id}&certUrl=${successObj?.data?.url}`,'_blank')

          } , (errorObj)=>{}))
        
        })
      );
      // dispatch({type : EDIT_LAST_CHALLENGE_CERTIFICATE_ID, payload : certificateStatus?.id })
      // dispatch(editRedirectType("linkedin_content_player"));
      // dispatch(
      //   editLastVisitedContent(
      //     `/${course_slug}/${skill_slug}/${mskill_slug}/${contentId}`
      //   )
      // );

      

      // const client_id = "78d1eot06iq0ru";
      // // console.log(client_id)
      // const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=${LINKEDIN_REDIRECT_URI}&response_type=code&scope=w_member_social r_liteprofile r_emailaddress`;
      // window.location.href = url;
      return { success: true };
    } catch (err) {
      console.log(err);
      return { success: false };
    }
  }

  // console.log(challengeInfo)
  const copyTextHandler = (link) => {
    navigator.clipboard.writeText(link);
    toast.success("Link Copied To Clipboard!");
  };
  console.log('mskillComplete' , mSkillProgress);

  return certificateStatus ? (
    <>
    <div></div>
      {certificateStatus?.certificate_unlock_status === "locked" &&
      challengeInfo?.["3day_challenge"] !== "completed" ? (
        <div className="flex flex-col items-center justify-start px-3 py-4">
          <div
            className={`mskillcomplete-parent flex w-full flex-col border-2 shadow-3xl items-center justify-between rounded-xl px-4 pt-4 pb-2 ${
              !isContentPlayer && "md:w-1/2"
            }`}
          >
            <p className="mb-4 flex flex-col self-start justify-center items-start  text-xl font-bold text-black">
              {isContentPlayer ? mSkillProgress ===100 ? 'Your Micro-Skill is complete. Unlock this certificate': (
                "Complete micro skill to unlock this certificate"
              ) : (
                <>
                  <p>Your Micro-Skill is complete.</p>
                  <p className="flex items-end justify-center">
                    Unlock this certificate
                    <img
                      urlEndpoint="https://assets.learntube.ai/files/"
                      src={
                        "https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471"
                      }
                      className="ml-2 h-6 w-6"
                      transformation={[
                        {
                          height: "60",
                          width: "60",
                        },
                      ]}
                    />
                  </p>
                  { !isTwoMskills && <p className="font-medium text-lg md:text-[16px] leading-tight mt-2 ">If not unlocked, your certificate will be removed in:<span className="inline-block"><Timer/></span> </p>}
                </>
              )}
            </p>
            {sampleMskillCertificateLink ? (
              <>
                <div className="relative flex flex-col items-center justify-center">
                  <img
                    src={sampleMskillCertificateLink}
                    alt="sample mskill certificate Link"
                    className="w-full rounded-lg"
                  />
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={
                      "https://assets.learntube.ai/files/Content_player/Group_7272.svg?updatedAt=1679056840095"
                    }
                    className="absolute bottom-0 w-full"
                  />
                  <div className="mskillcomplete-premium-feature flex justify-center items-center absolute top-0 right-0 rounded-tr-lg rounded-bl-lg px-2 py-1">
                    <img
                      urlEndpoint="https://assets.learntube.ai/files/"
                      src={
                        "https://assets.learntube.ai/files/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870"
                      }
                      className="w-4"
                    />
                  <div className="text-xs md:text-sm text-white ml-1">Premium Feature</div>
            </div>
                </div>
                {skillProgress?.progress !== 100 && (
                  <div className="mt-3 flex w-full items-center justify-center">
                    <div className="w-2/5">
                      <ProgressBar
                        bgcolor={"#54D15A"}
                        progress={skillProgress?.progress}
                        height={10}
                      />
                    </div>
                    <div className="md:text-md ml-2 whitespace-nowrap text-xs font-medium">
                      {skillProgress?.mskill_left_count} micro-skills left for
                      your
                    </div>
                    <div
                      className="md:text-md ml-1 cursor-pointer whitespace-nowrap text-xs font-medium text-pricing_blue underline"
                      onClick={(e) => setIsSkillPreview(true)}
                    >
                      full Skill certificate
                    </div>
                  </div>
                )}
              </>
            ) : (
              <Spinner />
            )}
            {isContentPlayer ? (
            <button
              className={`mt-4 w-3/4 rounded-md bg-[#FDBF48] px-3 py-3 font-bold ${
                !isContentPlayer && "md:w-1/2"
              }`}
              onClick={() =>
                setShowQuizPopup((prev) => ({ ...prev, open: false }))
              }
            >
              Got it!
            </button>
          ) : (
            <div
              className={`mt-4 flex flex-col items-center w-full  justify-center ${
                !isContentPlayer && ""
              }`}
            >
              <div className="flex flex-col items-center justify-center w-full ml-1">
                <button
                  className="flex items-center w-full justify-center rounded-md border-2 border-[#13B284] text-white bg-[#13B284] px-3 py-2 text-sm "
                  onClick={(e) => handlePremiumClick(e)}
                >
                  Unlock Unlimited Certificates
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={`https://assets.learntube.ai/files/Content_player/certificate_image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672151241471`}
                    className="ml-1 h-6 w-6"
                    transformation={[
                      {
                        height: "60",
                        width: "60",
                      },
                    ]}
                  />
                </button>
                <p className="text-sm my-1 flex ">
                  with <span className=" font-bold ml-1">LearnTube Pro</span>
                </p>
              </div>
              <Gamification
                mskill_slug={mskill_slug}
                callback={() => certificatePayDownload()}
                modalType={
                  challengeInfo?.["3day_challenge"] === "completed"
                    ? `${userActivity?.DOWNLOAD_FREE_CERTIFICATE.type}_quiz`
                    : `${userActivity?.DOWNLOAD_PAID_CERTIFICATE.type}_quiz`
                }
                activityDetails={
                  challengeInfo?.["3day_challenge"] === "completed"
                    ? userActivity?.DOWNLOAD_FREE_CERTIFICATE
                    : userActivity?.DOWNLOAD_PAID_CERTIFICATE
                }
                heroImage={sampleMskillCertificateLink}
              >
                <div className="flex flex-col items-center justify-center w-full mr-1 ">
                  <button
                    className="rounded-md w-full   py-[10px] text-sm font-medium text-pricing_blue"
                    onClick={() => {
                      setOpenConfirmationModal(true);
                      setType(
                        challengeInfo?.["3day_challenge"] === "completed"
                          ? `${userActivity?.DOWNLOAD_FREE_CERTIFICATE.type}_quiz`
                          : `${userActivity?.DOWNLOAD_PAID_CERTIFICATE.type}_quiz`
                      );
                    }}
                  >
                    or <span className="underline">Buy 1 certificate with 100 coins</span>
                  </button>
                </div>
              </Gamification>
            </div>
          )}
          </div>
          
          {!isContentPlayer && rangeBox?.style}
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center">
          {!isContentPlayer && challengeInfo?.['3day_challenge'] ==='completed' && <div className="flex flex-col justify-center items-start w-11/12 md:w-2/3 md:px-3 ">
            <div className="text-lg md:text-2xl mt-4 font-bold ">1-Day Challenge Completed!</div>
            { certificateStatus?.is_downloaded === false ? <div className="text-sm md:text-lg mt-2">Share your certificate to keep it unlocked forever!
If not shared, certificate will be <span className="font-bold">locked</span> again in:</div> :<div className="text-sm md:text-lg mt-2">Congratulations, you unlocked the certificate for free!</div> }
            {certificateStatus?.is_downloaded === false && <div className="mt-2 -ml-2"><ChallengeTimer/></div>}
          </div>}
          <div className="flex flex-col items-center justify-start px-3 py-4">
            <div
              className={`mskillcomplete-parent flex w-full flex-col items-center justify-between ${
                !isContentPlayer && "md:w-2/3"
              } rounded-lg p-3`}
            >
              {challengeInfo?.['3day_challenge'] !=='completed' && <p
                className={`text-md text-center font-bold text-black ${
                  !isContentPlayer && "md:text-xl"
                } mb-4 px-3`}
              >
                Congratulations! Share to showcase your skills & get more
                opportunities.
              </p>}
              {sampleMskillCertificateLink ? (
                <div className="relative flex flex-col items-center justify-center ">
                  <img
                    src={sampleMskillCertificateLink}
                    alt="sample mskill certificate Link"
                    className="w-full rounded-lg"
                  />
                  <img
                    urlEndpoint="https://assets.learntube.ai/files/"
                    src={
                      "https://assets.learntube.ai/files/Content_player/Group_7272.svg?updatedAt=1679056840095"
                    }
                    className="absolute bottom-0 w-full"
                  />
                  <div className="mskillcomplete-premium-feature flex justify-center items-center absolute top-0 right-0 rounded-tr-lg rounded-bl-lg px-2 py-1" >
                    <img
                      urlEndpoint="https://assets.learntube.ai/files/"
                      src={
                        "https://assets.learntube.ai/files/PRICING/img28.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662191682870"
                      }
                      className="w-4"
                    />
                    <div className="text-xs md:text-sm text-white ml-1">Premium Feature</div>
                  </div>
                   { (certificateStatus?.is_downloaded || challengeInfo?.['3day_challenge'] !=='completed') && <FontAwesomeIcon icon={faShareNodes} size="xl" className="text-white absolute left-1 top-1" onClick={(e)=> {
                    
                    dispatch(
                      getCertificate(userId, mskill_slug, (data) => {
                        dispatch(getCertificateUuid(data?.id,'mskill',(successObj)=>{

                          
                        setShareUrl(successObj?.data?.url)
              
                        }))
                      }
                      ))
                    
                    setShareModal(true)}} />}
                </div>
              ) : (
                <Spinner />
              )}
              {skillProgress?.progress !== 100 && (
                <div className="mt-3 flex  w-full items-center justify-center">
                  <div className="w-2/5">
                    <ProgressBar
                      bgcolor={"#54D15A"}
                      progress={skillProgress?.progress}
                      height={10}
                    />
                  </div>
                  <div className="ml-2 whitespace-nowrap text-xs font-medium md:text-[16px]">
                    {skillProgress?.mskill_left_count} micro-skills left for
                  </div>
                  <div
                    className="ml-1 cursor-pointer whitespace-nowrap text-xs font-medium text-pricing_blue underline md:text-[16px]"
                    onClick={(e) => setIsSkillPreview(true)}
                  >
                    full Skill certificate
                  </div>
                </div>
              )}
              <div className="mt-5 mb-2 flex w-full items-center justify-center">
                {
                  certificateStatus?.is_downloaded || challengeInfo?.['3day_challenge'] !=='completed' ? 
                  <>
                    <button
                    className="mr-3 flex items-center justify-center rounded-md bg-[#13B284] w-4/5 py-2 "
                    onClick={(e) => {
                      // if(certificateStatus?.is_downloaded)
                      // something
                      let flag = false;
                      let i;
                      for(i=0;i<mskillData.length;i++){
                        if(mskillData[i]?.mskill_slug === mskill_slug){
                          if(i === mskillData.length-1){
                            flag = true;
                          }
                          break;
                        }
                      }
                      // console.log(i);
                      // console.log(course_slug ,skill_slug, mskill_slug , mskillData[i])
                      if(flag === true){
                        navigate(`/${course_slug}/${skill_slug}/${mskillData[0]?.mskill_slug}/${mskillData[0]?.lessons_of_mskill[0]?.id}`)
                      }
                      else{
                        navigate(`/${course_slug}/${skill_slug}/${mskillData[i+1]?.mskill_slug}/${mskillData[i+1]?.lessons_of_mskill[0]?.id}`)
                      }
                      
                      
                      
                    }}
                    >

                    <p className=" whitespace-nowrap text-sm text-white font-semibold md:text-xl">
                      Continue Learning
                    </p> 
                  </button>
                  <button
                    className={`my-2 flex justify-center items-center rounded-md w-1/5 font-bold md:my-0 border-[2px] border-[#13B284] ${
                      isContentPlayer
                        ? "text-sm"
                        : "text-sm disabled:bg-gray-300 disabled:text-white md:text-base"
                    }  py-[6px] md:py-[8px]`}
                    onClick={(e) => {
                      setDownloadLoader(true);
                      certificateDownloadHandler();
                    }}
                    >
                     {downloadLoader ? (
                       <div className="h-6 w-6 animate-spin rounded-full border-4 border-black border-t-transparent" />
                       ) : (
                         <>
                      <FontAwesomeIcon
                        icon={faDownload}
                        size="xl"
                        className={`text-[#13B284]`}
                        />{" "}
                    </>
                  )}
                  </button>
                </>:
                <>
                <button
                  className="mr-3 flex items-center justify-center rounded-md bg-[#13B284] w-4/5 py-2 "
                  onClick={(e) => {
                    // if(certificateStatus?.is_downloaded)
                    // something
                    // else
                   
                    dispatch(
                      getCertificate(userId, mskill_slug, (data) => {
                        dispatch(getCertificateUuid(data?.id,'mskill',(successObj)=>{

                          
                        setShareUrl(successObj?.data?.url)
              
                        }))
                      }
                      ))
                      setShareModal(true);
                    
                    
                  }}
                >
                  <FontAwesomeIcon icon={faShareNodes} className="text-white" />
                  <p className="ml-2 whitespace-nowrap text-sm text-white font-semibold md:ml-4 md:text-xl">
                    Share Certificate
                  </p> 
                </button>
                <button
                  className={`my-2 flex justify-center items-center rounded-md w-1/5 font-bold md:my-0 border-[2px] ${ !certificateStatus?.is_shared ? 'border-green-300' :  'border-[#13B284]'} ${
                    isContentPlayer
                      ? "text-sm"
                      : "text-sm disabled:bg-gray-300 disabled:text-white md:text-base"
                  }  py-[6px] md:py-[8px]`}
                  disabled={downloadButtonDisabled}
                  onClick={(e) => {
                    if(certificateStatus?.is_shared){
                      setDownloadLoader(true);
                      certificateDownloadHandler();}
                      else{
                        toast.error("Share certificate first to download it for free.", {
                          position: "bottom-right",
                          autoClose: 5000,
                        });
                      }
                    }}
                    >
                  {downloadLoader ? (
                    <div className="h-6 w-6 animate-spin rounded-full border-4 border-black border-t-transparent" />
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={faDownload}
                        size="xl"
                        className={!certificateStatus?.is_shared ? 'text-green-300' : `text-[#13B284]`}
                      />{" "}
                    </>
                  )}
                </button>
              </>
}
              </div>
                  {!isContentPlayer && <div className="text-sm mt-0 md:text-lg md:w-full">Sharing your certificate increases your chances of getting hired by <span className="font-bold">62%</span></div>}
              {!isContentPlayer && isEpsCalculated && jesData && <div className="text-sm mt-4 md:text-lg self-start md:w-full">This will increase your job score by {jesData?.delta_score}</div>}
            </div>
            {/* {!isContentPlayer && (
              <div className="my-4 flex h-28 w-full flex-col items-center justify-between md:w-1/2">
                <button
                  className="w-3/4 rounded-md border-2 border-[#FDBF48] px-3 py-3 font-bold text-[#FDBF48]"
                  onClick={() => navigate(navigateTo)}
                >
                  Go to next Micro Skill
                </button>
              </div>
            )} */}
          </div>
        </div>
      )}
      {!isContentPlayer &&
        jesData && (last_completed_mskill?.mskill_slug === mskill_slug && last_completed_mskill?.display_jes ? (
        certificateStatus?.certificate_unlock_status === "locked" ? 
          <SpeedometerOne jesData={jesData} />
         : 
          <SpeedometerTwo jesData={jesData} />

        ) : <SpeedometerThree jesData={jesData}/>)}

      {isSkillPreview && (
        <Dialog
          open={isSkillPreview}
          onClose={() => {setIsSkillPreview(false)}}
          as="div"
          className="fixed inset-0 z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto md:mt-28 md:justify-start"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className=" relative top-7 z-20 flex w-[90%] flex-col items-center justify-center rounded-lg bg-white py-5 px-3 md:top-0 md:w-1/3">
            <div className="relative">
              <img src={skillCertificate?.certificate_image_link} alt="skill certificate link"></img>
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={
                  "https://assets.learntube.ai/files/Content_player/Group_7272.svg?updatedAt=1679056840095"
                }
                className="absolute bottom-0 w-full"
              />
            </div>
          </div>
        </Dialog>
      )}
      {shareModal && (
        <Dialog
          open={true}
          onClose={() =>{setShareModal(false)} }
          as="div"
          className="fixed inset-0 z-10 flex h-full w-full flex-col items-center justify-center overflow-y-auto md:mt-28 md:justify-start"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className=" absolute top-7 z-20 flex w-[90%] flex-col items-center justify-center rounded-lg bg-white py-4  px-3 md:top-0 md:w-1/3">
            <p className="my-3 text-center font-bold">
            Studies show sharing 6+ certificates on Social Media helps you get noticed by 4x more recruiters.
            </p>
            {sampleMskillCertificateLink ? (
              <div className="relative flex flex-col items-center justify-center">
                <img
                  src={sampleMskillCertificateLink}
                  alt="skill certificate link"
                  className="w-full md:h-2/3 md:w-2/3"
                />
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={
                    "https://assets.learntube.ai/files/Content_player/Certificate_overlay.png?ik-sdk-version=javascript-1.4.3&updatedAt=1670401923863"
                  }
                  className="absolute bottom-0 w-full md:w-2/3 "
                />
              </div>
            ) : (
              <Spinner />
            )}
            <div className="flex w-full items-center justify-between rounded-lg border-2 border-slate-200 px-2">
              <input
                type="text"
                name=""
                id=""
                value={shareUrl}
                readOnly={true}
                className="w-[90%] border-white text-xs text-pricing_blue focus:border-transparent focus:ring-0"
              />
              <FontAwesomeIcon
                icon={faCopy}
                className="cursor-pointer text-slate-400"
                onClick={() =>{
                  updateMskillCertificate()

                  copyTextHandler(
                    shareUrl
                  )
                }
              }
              />
            </div>
            <div className="my-4 flex">
              <button
                className="mr-4 cursor-pointer md:mr-6"
                onClick={(e) => {
                  updateMskillCertificate()
                  e.stopPropagation();
                  linkedinAuth();
                }}
              >
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Content_player/linkedinIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657788903033`}
                  className="h-7 w-7"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </button>
              <FacebookShareButton
                url={verifyCertificateUrl}
                quote={
                  "Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."
                }
                hashtag="#learntube"
                className="mr-4 text-gray-500 md:mr-6"
                onClick={(e)=> updateMskillCertificate()}
              >
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Content_player/facebookIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657788903110`}
                  className="h-7 w-7"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </FacebookShareButton>
              <WhatsappShareButton
                url={verifyCertificateUrl}
                title={
                  "Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."
                }
                className="mr-4 text-gray-500 md:mr-6"
                onClick={(e)=> updateMskillCertificate()}
              >
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Content_player/whatsappIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657788903358`}
                  className="h-7 w-7"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </WhatsappShareButton>
              <TwitterShareButton
                title={
                  "Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."
                }
                url={`https://learntube.ai?ref=${uniqueCertificateId}`}
                via={"CareerNinjaIn"}
                hashtags={["learntube", "careerninja"]}
                className="mr-4 text-gray-500 md:mr-6"
                onClick={(e)=> updateMskillCertificate()}
              >
                <img
                  urlEndpoint="https://assets.learntube.ai/files/"
                  src={`https://assets.learntube.ai/files/Content_player/twitterIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657788903140`}
                  className="h-7 w-7"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </TwitterShareButton>
            </div>
            <p className="my-4 text-center font-bold">
            Add certificate to your LinkedIn in 1-Click
            </p>
            <button
              className="flex items-center justify-between rounded-xl bg-[#02659C] pr-4 font-bold text-white"
              onClick={(e) => {
                e.stopPropagation();
                linkedinAuth();
              }}
            >
              <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={`https://assets.learntube.ai/files/Content_player/linkedinIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657788903033`}
                className="mr-4 h-12 w-12"
                transformation={[
                  {
                    height: "60",
                    width: "60",
                  },
                ]}
              />
              Add Your Certificate
            </button>
            {/* <FontAwesomeIcon
              icon={faTimes}
              className="absolute top-2 right-2"
              size="lg"
              onClick={() => setShareModal(false)}
            /> */}
          </div>
        </Dialog>
      )}
      {/* {!isEpsCalculated && 
      <button
        className="my-4 mx-auto flex items-center justify-center rounded-3xl bg-gradient-to-r from-[#13A0BD] to-[#086788] px-3 py-3 text-white"
        onClick={() => {
          Mixpanel.track(Constants.Mixpanel.JES_ENTRY_CERTIFICATE_ICON, {
            distinct_id: email,
          });
          navigate("/my-profile/user");
        }}
      >
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src="https://assets.learntube.ai/files/Profile-section/thumbUp.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1666696717785"
          className="mr-2 h-6 w-6 md:h-8 md:w-8"
          transformation={[
            {
              height: "50",
              width: "50",
            },
          ]}
        />
        Calculate My Job Score
      </button>
} */}
    </>
  ) : (
    <Spinner />
  );
}
